var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"form-element-select-demo"}},[_c('select-single-selection'),_c('select-color'),_c('select-autocomplete'),_c('select-multiple'),_c('select-labels'),_c('select-validators'),_c('select-is-selected-item'),_c('select-group-items')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }